import React from "react";
import classNames from "classnames";
import { RequestStatus } from "../../../../types/mydata";
import { Typography } from "../../../../components/__common/Typography/Typography";

interface StepsProps {
  status: RequestStatus;
}

export const Steps: React.FC<StepsProps> = (props) => {
  const { status } = props;
  const allowedStatuses = [
    RequestStatus.COMPLETED,
    RequestStatus.PROCESSING,
    RequestStatus.REQUESTING,
    RequestStatus.QUEUED,
  ];

  // Treat REQUESTING and QUEUED as PROCESSING for step display
  const isRequestProcessing =
    status === RequestStatus.PROCESSING ||
    status === RequestStatus.REQUESTING ||
    status === RequestStatus.QUEUED;

  return (
    <>
      {allowedStatuses.includes(status) && (
        <div className="request-details__steps">
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: isRequestProcessing,
              prev: status === RequestStatus.COMPLETED,
            })}
          >
            {isRequestProcessing ? 1 : ""}
          </Typography>
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.COMPLETED,
            })}
          >
            {status === RequestStatus.COMPLETED ? 2 : ""}
          </Typography>
        </div>
      )}
    </>
  );
};
